import type { RoutesPlannerTask } from '@bringg-frontend/routes-planner';

export const getTaskRange = (task: RoutesPlannerTask) => {
	const wayPoint = task.way_points[0];
	const start =
		wayPoint.eta ||
		wayPoint.scheduled_at ||
		wayPoint.no_earlier_than ||
		wayPoint.first_attempt_promise_no_earlier_than ||
		null;
	const end = wayPoint.etl || wayPoint.no_later_than || wayPoint.first_attempt_promise_no_later_than || null;

	return { start, end };
};
const getMaxAndMinTasksRange = (tasks: RoutesPlannerTask[]) => {
	let min;
	let max;
	tasks.forEach(task => {
		const { start: minWayPointTime, end: maxWayPointTime } = getTaskRange(task);

		if (minWayPointTime && (!min || minWayPointTime < min)) {
			min = minWayPointTime;
		}

		if (maxWayPointTime && (!max || maxWayPointTime > max)) {
			max = maxWayPointTime;
		}
	});
	return { min, max };
};
export const tasksRangeTime = { getMaxAndMinTasksRange, getTaskRange };
